import { render, staticRenderFns } from "./PDFExportTemplates.vue?vue&type=template&id=3fe8c64a&"
import script from "./PDFExportTemplates.vue?vue&type=script&lang=js&"
export * from "./PDFExportTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports